
import "../Foundation/stylable/colors.st.css.js";
import "../Foundation/stylable/border.st.css.js";
import "../Foundation/stylable/easing.st.css.js";
import "../common/Focusable/Focusable.st.css.js";
import { classesRuntime, statesRuntime } from "./../stylable-esm-runtime.js";



var _namespace_ = "wds_1_180_0_ImageViewer";
var _style_ = classesRuntime.bind(null, _namespace_);

export var cssStates = statesRuntime.bind(null, _namespace_);
export var style = _style_;
export var st = _style_;

export var namespace = _namespace_;
export var classes = {"root":"wds_1_180_0_ImageViewer__root","buttons":"wds_1_180_0_ImageViewer__buttons","imageContainer":"wds_1_180_0_ImageViewer__imageContainer","overlay":"wds_1_180_0_ImageViewer__overlay","image":"wds_1_180_0_ImageViewer__image","statusContainer":"wds_1_180_0_ImageViewer__statusContainer"};
export var keyframes = {}; 
export var layers = {};
export var containers = {};
export var stVars = {}; 
export var vars = {}; 




